import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-note",
  "use": "icon-note-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-note\"><path d=\"M8.481 8.482h3.704V1.815H1.815v10.37H8.48zM.333 13.667V.333h13.333v8.89l-4.444 4.444zm2.963-5.185V7H7v1.482zm0-2.963V4.037h7.407V5.52zm-1.482 6.666V1.815z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol